var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import clsx from 'clsx';
import { withForwardedRef } from '../utils/helpers/reactHelpers';
import Typography from '../Typography';
import Link from '../Link';
const ErrorBannerSC = styled.div `
  outline: 0;
  width: auto;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  height: auto;
  border-radius: ${(p) => p.theme.SizeBorderRadiusErrorBannerBase};
  font-family: ${(p) => p.theme.FontFamilyBase};
  font-weight: ${(p) => p.theme.ContentFontWeightNormal};
  white-space: nowrap;

  padding: ${(p) => p.theme.SizePaddingErrorBannerMedium};
  background-color: ${(p) => p.theme.ColorBackgroundErrorBannerMedium};
  color: ${(p) => p.theme.ColorFontErrorBannerBase};

  ._ndsErrorBanner__label {
    white-space: normal;

    a {
      font-size: ${(p) => p.theme.SizeFontErrorBannerMedium};
      line-height: ${(p) => p.theme.SizeLineHeightErrorBannerMedium};
    }
  }

  ._ndsErrorBanner__icon {
    min-width: ${(p) => p.theme.SizeIconErrorBannerMedium};
    margin-right: ${(p) => p.theme.SizeMarginErrorBannerIcon};
    fill: ${(p) => p.theme.ColorIconErrorBannerMedium};
  }

  ._ndsErrorBanner__action {
    margin-left: ${(p) => p.theme.SizeMarginErrorBannerAction};
    color: ${(p) => p.theme.ColorLinkErrorBannerMedium};
    box-shadow: none;
  }

  &._ndsErrorBanner--high {
    padding: ${(p) => p.theme.SizePaddingErrorBannerHigh};
    background-color: ${(p) => p.theme.ColorBackgroundErrorBannerHigh};
    color: ${(p) => p.theme.ColorFontErrorBannerBase};

    ._ndsErrorBanner__icon {
      min-width: ${(p) => p.theme.SizeIconErrorBannerHigh};
      fill: ${(p) => p.theme.ColorIconErrorBannerHigh};
    }

    ._ndsErrorBanner__label {
      a {
        font-size: ${(p) => p.theme.SizeFontErrorBannerHigh};
        line-height: ${(p) => p.theme.SizeLineHeightErrorBannerHigh};
      }
    }

    ._ndsErrorBanner__action {
      color: ${(p) => p.theme.ColorLinkErrorBannerHigh};
    }
  }

  &._ndsErrorBanner--full-width {
    width: 100%;
  }
`;
const IconAndLabelWrapper = styled.div `
  display: inline-flex;
  align-items: center;
`;
const ErrorBanner = (props) => {
    const { label, fullWidth, attentionLevel, icon, action, onAction, forwardedRef, className: classNameProp } = props, others = __rest(props, ["label", "fullWidth", "attentionLevel", "icon", "action", "onAction", "forwardedRef", "className"]);
    const isHighAttention = attentionLevel === 'high';
    const classes = React.useMemo(() => clsx({
        '_ndsErrorBanner--high': isHighAttention,
        '_ndsErrorBanner--full-width': fullWidth
    }, classNameProp), [classNameProp, isHighAttention, fullWidth]);
    const iconComp = React.useMemo(() => {
        if (icon && React.isValidElement(icon)) {
            return React.cloneElement(icon, {
                className: clsx('_ndsErrorBanner__icon', icon.props && icon.props.className),
                size: isHighAttention ? 'm' : 's',
                'data-testid': 'ErrorBannerIcon'
            });
        }
        return null;
    }, [icon, isHighAttention]);
    return (React.createElement(ErrorBannerSC, Object.assign({ ref: forwardedRef, className: classes }, others),
        React.createElement(IconAndLabelWrapper, null,
            iconComp,
            React.createElement(Typography, { className: "_ndsErrorBanner__label", variant: isHighAttention ? 'body3' : 'body4' }, label)),
        action && onAction && (React.createElement(Link, { onClick: onAction, size: isHighAttention ? 'm' : 's', className: "_ndsErrorBanner__action", "data-testid": "ErrorBannerAction" }, action))));
};
ErrorBanner.propTypes = {
    label: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
        PropTypes.string
    ]).isRequired,
    attentionLevel: PropTypes.oneOf(['high', 'medium']),
    fullWidth: PropTypes.bool,
    icon: PropTypes.element,
    action: PropTypes.string,
    onAction: PropTypes.func,
    className: PropTypes.string,
    forwardedRef: PropTypes.any
};
ErrorBanner.defaultProps = {
    attentionLevel: 'medium',
    fullWidth: undefined,
    icon: undefined,
    action: undefined,
    onAction: null,
    className: undefined,
    forwardedRef: null
};
export { ErrorBanner as ErrorBannerRootComp };
export default withForwardedRef(ErrorBanner);
//# sourceMappingURL=ErrorBanner.js.map